import "@electricMotorShop/Store/AdditionalOrderInfomationReducer";
import "@electricMotorShop/Store/Components/FlyoutDrawer/FlyoutDrawerReducer";
import "@electricMotorShop/Store/Components/ProductAvailability/ProductAvailabilityReducer";
import "@electricMotorShop/Store/Data/AccountSettings/AccountSettingsReducer";
import "@electricMotorShop/Store/Data/DynamicForms/DynamicFormReducer";
import "@electricMotorShop/Store/Data/NewProducts/NewProductsReducer";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// in production, the widget extensions are included in the chunks created for widgets
if (!IS_PRODUCTION) {
    //     // load all widget extensions. They could be loaded individually instead
    const widgetExtensions = require.context("./WidgetExtensions", true);
    widgetExtensions.keys().forEach(key => widgetExtensions(key));
}

// Post Style Guide
setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 600, 798, 1230, 1530],
        maxWidths: [480, 570, 768, 1199, 1500],
    },
    typography: {
        fontFamilyImportUrl:
            "https://fonts.googleapis.com/css?family=Montserrat:100,200,300,regular,500,600,700,800,900,100italic,200italic,300italic,italic,500italic,600italic,700italic,800italic,900italic|Open+Sans:300,regular,500,600,700,800,300italic,italic,500italic,600italic,700italic,800italic&#038;subset=cyrillic,cyrillic-ext,latin,latin-ext,vietnamese,greek,greek-ext,hebrew&#038;display=swap",
        body: {
            fontFamily: "'Montserrat'",
        },
        headerPrimary: {
            fontFamily: "'Montserrat'",
        },
        headerSecondary: {
            fontFamily: "'Montserrat'",
        },
        headerTertiary: {
            fontFamily: "'Montserrat'",
        },
    },
    focus: {
        width: "0px",
    },
    globalStyle: {
        css: css`
            button {
                border-radius: 4px !important;
                box-shadow: none !important;
            }
        `,
    },
    pagination: {
        defaultProps: {
            buttonProps: {
                color: "text.main",
                css: css`
                    background: none;
                    border: 2px solid transparent;
                    transition: none;
                    min-height: 40px;
                    span {
                        color: ${getColor("text.main")};
                        font-weight: bold;

                        svg {
                            color: ${getColor("text.main")};
                        }
                    }

                    &:not(:disabled):hover {
                        color: ${getColor("text.main")};
                        background: none;
                        border-color: ${getColor("primary.main")};
                    }

                    :disabled span {
                        color: ${getColor("common.border")};

                        svg {
                            color: ${getColor("text.main")};
                        }
                    }
                `,
            },
            cssOverrides: {
                currentButton: css<any>`
                    background: ${getColor("primary.main")};
                    border-color: ${getColor("primary.main")};
                    color: ${getColor("primary.contrast")};

                    span {
                        color: ${getColor("primary.contrast")};
                    }
                `,
            },
            selectProps: {
                cssOverrides: {
                    formField: css`
                        width: 240px;
                        padding-right: 15px;
                        margin-right: -90px;
                        margin-left: 16px;
                    `,
                    formInputWrapper: css`
                        max-width: 75px;
                    `,
                },
                labelProps: {
                    css: css`
                        width: auto;
                    `,
                },
            },
        },
    },
});
